export default "__VITE_ASSET__BlNEgJT7__"